export default __webpack_public_path__ + "static/media/logo.d60dd3f2.svg";